import React from "react";

const Information: React.FC = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Souhrn všech možných informací nahromadě, než se náš web dostane do finalní podoby</h1>
      <h2>Čipování želv</h2>
      <p>Malé želvy by se čipovat neměli. Navíc je idální aby podobný výkon dělal veterinář.</p>
      <ul>
        <li>Novinky.cz: <a href="https://www.novinky.cz/clanek/veda-skoly-cipovani-zelvicek-je-tyrani-nedelejte-to-varuji-veterinari-40438982
" target="_blank" rel="noreferrer">Čipování želviček je týrání, nedělejte to, varují veterináři</a></li>
      </ul>
      <h2>Původ želv</h2>
      <p>Při koupi od pana Junka z e-shopu euzelva.cz se vám, stejně jako nám, může stát, že bude pocházet ze slovinské velkofarmy. Tím dostává "prodej želv od chovatele" trochu jiný rozměr, že?</p>
      <ul>
        <li>Instagram farmy odkud pan Junek odebírá: <a href="https://www.instagram.com/dular_ziga/" target="_blank" rel="noreferrer">https://www.instagram.com/dular_ziga/</a></li>
      </ul>
    </div>
  );
};

export default Information;
